import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';

// Classes.
import { Logger } from '../../lib/classes/logger';
import { Article } from '../../lib/classes/article';

// Services.
import { DataService } from '../../lib/services/data/data.service';
import { LoggerService } from '../../lib/services/logger/logger.service';
import { ScrollService } from '../../lib/services/scroll/scroll.service';
import { ContextService } from '../../lib/services/context/context.service';

// Pipes.
import { SafeHtmlPipe } from '../../lib/pipes/safe-html/safe-html.pipe';
import { LanguageService } from '../../lib/services/lang/language.service';
import { Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';



@Component({
  selector: 'app-flying-page',
  templateUrl: './flying-page.component.html',
  styleUrls: ['./flying-page.component.scss']
})
export class FlyingPageComponent implements OnInit, OnDestroy {

  // FLying pages are modeled exactly the same as an Article, so we use that
  // class.
  public article: Article;

  public id: string;
  public root: any;
  public showNav: boolean;
  public isMobile: boolean;
  protected logger: Logger;
  private sub: Array<Subscription> = [];

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private context: ContextService,
    protected scroll: ScrollService,
    public lang: LanguageService,
    loggerSrvc: LoggerService
  ) {
    this.logger = new Logger(loggerSrvc, this.constructor.name);
    this.isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
    this.showNav = (this.isMobile) ? true : this.context.getShowNav();
  }


  ngOnInit() {
    // Reserve the constructor for simple initialization such as wiring
    // constructor parameters to properties. The constructor shouldn't do anything.
    // It certainly shouldn't call a function that makes HTTP requests to a
    // remote server as a real data service would.
    if (typeof this.route !== 'undefined'
      && typeof this.route.params !== 'undefined') {
      this.route.params.subscribe(
        params => this.processParams(params),
        error => this.processError(error));
    }
    this.scroll.scrollToContentOnNavigationEnd();
  }
  ngOnDestroy() {
    this.sub.forEach(value => value.unsubscribe());
  }
  public processParams(params) {
    this.showNav = (this.isMobile) ? true : this.context.getShowNav();
    this.id = params['id'];
    this.getFlyingPage();
  }

  getFlyingPage(): void {
    let flyingPage$ = this.dataService.getFlyingPage(this.id);

    if (flyingPage$) {
      this.sub.push(
        this.lang.lang().asObservable().pipe(
          mergeMap(a =>
            this.dataService.getFlyingPage(this.id)

          )).subscribe(
            article => this.processReceivedFlyingPage(article),
            err => this.processError(err)
          ));
    }

  }

  processReceivedFlyingPage(flyingPage: Article) {
    this.article = flyingPage;

    // If article parent its 0 means thats is book root, we want to
    // show book children instead of book brothers.
    this.root = Number(this.article.parent) == 0 ? this.article.id : this.article.parent;

  }
  processError(error: any): void {
    this.logger.error(`Error in ${this.constructor.name} (BA5E03CD)`, error);
  }
}
